
import moment from 'moment'
import { mapState } from 'vuex'

import SingleProduct from '../SingleProduct'
import Icon from '../Icon'

export default {
  name: 'Upsells',
  components: { Icon, SingleProduct },
  props: {
    upsells: Array,
    config: Object,
  },
  data() {
    return {
      scroll: 0,
      innerWidth: 0,
      fullWidth: 0,
      cardWidth: 0,
    }
  },
  mounted() {
    setTimeout(() => {
      const $section = document.getElementById('upsells')
      if ($section) {
        this.innerWidth = $section.scrollWidth
      }
      const $items = document.getElementById('upsells-list')
      if ($items) {
        this.fullWidth = $items.scrollWidth
        if ($items.children && $items.children.length > 0) {
          this.cardWidth = $items.children[0].offsetWidth
        }
      }
    }, 500)
  },
  computed: {
    ...mapState(['location', 'appInfo']),
    showNavigation() {
      if (this.fullWidth > this.innerWidth && this.config?.navigationArrows?.rightIconName && this.config?.navigationArrows?.leftIconName) {
        return true
      }
      return false
    },

    nowTimeAtLocation() {
      let loc = this.location
      const localUtcOffset = moment().utcOffset() / 60
      const locationUtcOffset = loc.utcoffset || loc.utcOffset
      const absoluteLocalUtcOffset = Math.abs(localUtcOffset)
      const absoluteLocationUtcOffset = Math.abs(locationUtcOffset)
      const difference = Math.abs(localUtcOffset - locationUtcOffset)

      let now = moment()
      if (absoluteLocalUtcOffset < absoluteLocationUtcOffset) {
        // local time is ahead
        now = moment().subtract(difference, 'hours')
      } else if (absoluteLocalUtcOffset > absoluteLocationUtcOffset) {
        // local time is behind
        now = moment().add(difference, 'hours')
      }

      return now
    },
    quickAddOnly() {
      return this.appInfo?.menu?.upsells?.quickAddOnly !== false
    },
  },
  methods: {
    leftScroll() {
      const element = document.getElementById('upsells-list')
      if (element) {
        const targetScroll = element.scrollLeft - this.cardWidth
        this.smoothScrollTo(element, targetScroll)
      }
    },
    rightScroll() {
      const element = document.getElementById('upsells-list')
      if (element) {
        const targetScroll = element.scrollLeft + this.cardWidth
        this.smoothScrollTo(element, targetScroll)
      }
    },
    smoothScrollTo(element, targetScroll) {
      const startScroll = element.scrollLeft
      const distance = targetScroll - startScroll
      const duration = 300 // Animation duration in milliseconds
      const startTime = performance.now()

      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)

        // Easing function for smooth animation
        const easeOutCubic = 1 - Math.pow(1 - progress, 3)

        element.scrollLeft = startScroll + distance * easeOutCubic

        if (progress < 1) {
          requestAnimationFrame(animateScroll)
        } else {
          // Update the scroll state after animation completes
          this.updateScroll()
        }
      }

      requestAnimationFrame(animateScroll)
    },
    updateScroll() {
      const $items = document.getElementById('upsells-list')
      if ($items) {
        this.scroll = $items.scrollLeft
      }
    },
    isAvailable(prod) {
      const now = this.nowTimeAtLocation
      const availableFrom = moment(prod?.availability.start).format()
      const availableTo = moment(prod?.availability.end).format()

      if (moment(now).isSameOrAfter(availableFrom) || moment(now).isSameOrBefore(availableTo) || prod?.availability.now) {
        return true
      }
      return false
    },
  },
}
